import { OrderCenterConfigPaymentFormBindQueryModel } from './order-center-config.model';

export class iFood {
   public Id: string;
   public CompanyId: number;
   public IsIfoodEnabled: boolean;
   public IfoodMerchantIds: string[];
   public UseIfoodDeliveryService: boolean;
   public IfoodAutomaticallyAcceptOrders: boolean;
   public IsIfoodOnDemandEnabled: boolean;
   public IfoodOnDemandDefaultMotoboyId: string;
   public IfoodOnDemandDefaultMotoboyName: string;
   public IfoodAdditionalFeeProductId: string;
   public IfoodAdditionalFeeProductName: string;
   public PaymentFormBinds: OrderCenterConfigPaymentFormBindQueryModel[];
   public CreatedOn: Date;
   public CreatedBy: string;
   public LastModifiedOn: Date;
   public LastModifiedBy: string;

   constructor() {
      this.IsIfoodEnabled = false;
      this.UseIfoodDeliveryService = false;
      this.IfoodAutomaticallyAcceptOrders = false;
      this.IsIfoodOnDemandEnabled = false;
      this.IfoodMerchantIds = [];
   }
}

export class OrderCenterConfigIfoodMerchantInfo {
   public Id: string;
   public MerchantId: string;
   public MerchantName: string;
   public FormattedAddress: string;
}
export class OrderCenterConfigIfoodMerchantInfoCustom {
   public Id: string;
   public Name: string;
   public FormattedAddress: string;
}

export class OrderCenterOnDemandConfigResponse {
   public CompanyId: number;
   public UseIfoodDeliveryService: string;
   public IsIfoodOnDemandEnabled: string;
   public IfoodMerchants: OrderCenterConfigIfoodMerchantInfo[];
   public IfoodMerchantsCustom: OrderCenterConfigIfoodMerchantInfoCustom[];
}

export class GetDeliveryQuoteResponse {
   Success: boolean;
   ErrorCode: string;
   ErrorMessage: string;
   DeliveryQuote: DeliveryQuoteInfo;
}

export class DeliveryQuoteInfo {
   Id: string;
   IfoodMerchantId: string;
   ExpirationAt: Date;
   CreatedAt: Date;
   Distance: number;
   PreparationTime: number;
   Quote: QuoteInfo;
   DeliveryTime: DeliveryTimeInfo;
   HasPaymentMethods: boolean;
   PaymentMethods: PaymentMethodInfo[];
}

export class DeliveryTimeInfo {
   Min: number;
   Max: number;
}

export class PaymentMethodInfo {
   Id: string;
   Brand: string;
   Liability: string;
   PaymentType: string;
   Method: string;
}

export class QuoteInfo {
   GrossValue: number;
   Discount: number;
   Raise: number;
   NetValue: number;
}

export class RequestDeliveryDriverRequest {
   QuoteId: string;
   IfoodMerchantId: string;
   DeliveryValue: number;
}

export class DeliveryDriverInfo {
   Success: boolean;
   ErrorCode: string;
   ErrorMessage: string;
   IntegrationId: string;
   TrackingUrl: string;
}
